module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAaCAYAAABozQZiAAAAAXNSR0IArs4c6QAAAN1JREFUOBFjYCAB/P//XwmID0KxCNFaoRofAWkYsCNKM1A1yEZkjXuBfCaCmrFo3AMU4yRH425yNe4iV+NOoEYOcpy6g+4atwNtZCfHqdvI1biVKI0gJwEVgiIdBrYAGWwEnQpVAEpifEiKtzMyMv5C4uNnAm0yAuJ3UKv/AekM/DrQZLEYkI2mBD8XzQCQQ3Lx60CTxWJAAZoS/FwsBhTj14Emi8WAMjQl+LlYDKjErwNNFosBtWhK8HOxGNCAXweaLBYDatCU4OeiGfALyCe+3AYZDTXgIpA+BcRsAMjw5f3EfIoaAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/whiteGo.png
// module id = s54z
// module chunks = 1